<div *ngIf="isSkelition" class="d-flex justify-content-center">
    <p-progressSpinner></p-progressSpinner>
</div>

<div class="active-panel" *ngIf="isMainTrainer && !isSkelition">
    <h5 class="heading textt-900 mx-2 mt-2 tab" [class.active]="CurrTab === 'User'"
        (click)="ChangeTab('User', $event)">
        {{ "User Rating" | translator }}
    </h5>
    <h5 class="heading textt-900 mx-2 mt-2 tab" [class.active]="CurrTab === 'Trainer'"
        (click)="ChangeTab('Trainer', $event)">
        {{ "Trainers Rating" | translator }}
    </h5>
</div>

<p-table [value]="courseTrainers" *ngIf="isUser && !isSkelition" [tableStyle]="{'min-width': '50rem'}" [paginator]="true" [rows]="5">
    <ng-template pTemplate="header">
      <tr>
        <th>{{'Name' | translator}}</th>
        <th>{{'Email' | translator}}</th>
        <th>{{'Action' | translator}}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-trainers>
      <tr>
        <td>{{trainers?.name}}</td>
        <td>{{trainers?.email}}</td>
        <td>
            <button *ngIf="checkSurveyAttempt(trainers.rating,trainers.user_id ); else showCheckIcon" (click)="openAttempt(trainers.user_id)" class="main-btn py-2 my-3">
                {{ "Give Rating" | translator }}
            </button>
            <ng-template #showCheckIcon>
                <p-rating
                        [(ngModel)]="trainers.avg_rating" 
                        [readonly]="true"
                        [cancel]="false"
                    ></p-rating>
            </ng-template>
        </td>
      </tr>
    </ng-template>
</p-table>

<p-table [value]="courseUsers" *ngIf="!isUser && !isSkelition" [tableStyle]="{'min-width': '50rem'}" [paginator]="true" [rows]="5">
    <ng-template pTemplate="header">
      <tr>
        <th>{{'Name' | translator}}</th>
        <th>{{'Email' | translator}}</th>
        <th>{{'Action' | translator}}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-users>
      <tr>
        <td>{{ getName(users?.name) }}</td>
        <td>{{users?.email}}</td>
        <td>
            <button *ngIf="checkSurveyAttempt(users.rating, users.userId); else showCheckIcon" (click)="openAttempt(users.userId)" class="main-btn py-2 my-3">
                {{ "Give Rating" | translator }}
            </button>
            <ng-template #showCheckIcon>
                <div *ngIf="checkRatingSubmitted(users.rating,users.userId); else showRating" class="d-flex justify-content-start my-2">
                    <button *ngIf="true" (click)="openAttempt(users.userId)" class="main-btn py-2 my-3">
                        {{ "Edit" | translator }}
                    </button>
                    <button *ngIf="true" (click)="updateAttempt(users.rating,users.userId)" class="main-btn py-2 my-3">
                        {{ "Submit" | translator }}
                    </button>
                </div>
                <ng-template #showRating>
                    <p-rating
                        [(ngModel)]="users.avg_rating" 
                        [readonly]="true"
                        [cancel]="false"
                    ></p-rating>
                </ng-template>
            </ng-template>
        </td>
      </tr>
    </ng-template>
</p-table>


